/**
 * Public help area. Opens without a session, so it lives outside the panel
 * routes and must stay declared before the panel `users/:id` route.
 */
export const HELP_INDEX_PATH = '/users/doc';

export const helpSectionPath = (slug: string): string => `${HELP_INDEX_PATH}/${slug}`;
